import React, { useState, useEffect } from "react";
import { Modal } from "react-bootstrap";
import dummyImage from "../../Assets/Group 1171283252[1].png";
import getTranslationData from "../../TranslationUtility/TranslationUtility";

const SelectWidgetCardModel = ({ show, handleClose, modalClass, cardList, cardSelectHandle }) => {
    const translation = getTranslationData();
    const handleImageError = (e) => {
        e.target.onerror = null; // Prevent infinite loop if fallback fails
        e.target.src = dummyImage; // Set fallback
    };
    return (
        <div className="modal_Quick">
            <Modal
                show={show}
                onHide={handleClose}
                size="lg"
                aria-labelledby="exampleModalLabel"
                centered
                className={`earn-points-modal widget-card  ${modalClass}`}
            >
                {/* <ToastContainer /> */}
                <Modal.Body>
                    <div
                        id="WidgetCardSelectModel"
                        className="body position-relative-QuickModal widget-card-select-model"
                    >
                        {/* Fixed Header */}
                        <div className="d-flex my-3 justify-content-between align-items-center fixed-top">
                            <div>
                                <div className="popup-header mb-5-px">
                                    <h5 className="heading mb-0">{translation?.widget_popup_title}</h5>
                                    <span
                                        className="modal-cross"
                                        role="button"
                                        onClick={handleClose}
                                    >
                                        <i className="fa-solid fa-xmark xmark_FS"></i>
                                    </span>
                                </div>
                            </div>
                        </div>
                        {/* Scrollable Content */}
                        <div className="modal-content-scrollable p-0">

                            <div className="border rounded-3 overflow-hidden">
                                {cardList?.map((card, index) => {
                                    return <><div
                                        className={`widget-card-list d-flex align-items-center shadow-sm 
                                            ${card?.isSelected ? index === 0 ? "rounded-top-3 widget-card-selectd" :
                                                index === (cardList.length - 1) ? "rounded-bottom-3 widget-card-selectd" : 'widget-card-selectd'
                                                : 'bg-white'}`}
                                        key={`${card.cardId}-${index}`}
                                        onClick={() => cardSelectHandle(card, index)}
                                    >
                                        <img src={`${process.env.REACT_APP_CLIENT_URL}${card?.cardThumbnailUrl}`} onError={handleImageError} alt="CrdImg"></img >
                                        <div className='px-3 flex-grow-1 '>
                                            <div className="bold">{translation?.american_express} {card?.cardName} </div>
                                            <div className={`widget-multiplier ${card?.isSelected ? "" : "widget-multiplier-color"} `}>{translation?.widget_earn_txt} {card.description}</div>
                                        </div>
                                    </div >
                                        {cardList.length === (index + 1) ? <></> : <hr className="m-0" />}
                                    </>
                                })}
                            </div>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </div >
    )
}

export default SelectWidgetCardModel